import MonochromeSidebarLeftModernThumbnailPath from '../../../assets/template-thumbnails/sidebar-left/monochrome-modern-sidebar-left-template-thumbnail.png';

const MonochromeSidebarLeftModernTemplate = {
    id: 'monochrome-modern-sidebar-left-template',
    name: 'Monochrome Modern',
    category: 'Sidebar Left Modern',
    settings: {
      layoutId: 'sidebar-left',
      designId: 'custom',
      style: 'tech',
      background: 'blank',
      barStyleId: 'bars',
      specialEffectId: 'timeline',
      customColors: {
        primary: "#333333",
        secondary: "#111111",
        tertiary: "#555555",
        quaternary: "#666666",
        accent1: "#888888",
        accent2: "#999999",
        accent3: "#AAAAAA",
        accent4: "#BBBBBB",
        accent5: "#CCCCCC",
        accent6: "#DDDDDD",
        accent7: "#EEEEEE",
        accent8: "#FFFFFF",
        text: "#111111",
        textSecondary: "#666666",
        background: "#FFFFFF",
        sidebarBackground: "rgba(51, 51, 51, 1)",
        border: "rgba(51, 51, 51, 1)",
        sidebarPrimary: "rgba(255, 255, 255, 1)",
        sidebarText: "rgba(255, 255, 255, 1)"
      },
      typography: {
        cvTitle: { fontSize: 24, lineHeight: 1.4, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 12, lineHeight: 1.2, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 10, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: MonochromeSidebarLeftModernThumbnailPath
  };

export default MonochromeSidebarLeftModernTemplate; 